//import Webview from '@component/native/visible/Webview'
import {VideoBridgeGetFileInfo} from '../../src/api'
import App from "../class/App";

export function fireEvent(eventName, eventData) {
    var ev = document.createEvent('HTMLEvents')
    ev.initEvent(eventName, false, true)
    ev.param = eventData
    document.dispatchEvent(ev)
}

export function getWebview() {
    return new Webview()
}

/**
 * 注册全局属性
 * @param propertyName
 * @param property
 */
export function registerPublicProperty(propertyName, property) {
    window.mtg_public_property = window.mtg_public_property || {}
    window.mtg_public_property[propertyName] = property
}

/**
 * 获取全局属性
 * @param propertyName
 * @param property
 */
export function getPublicProperty(propertyName, property) {
    return window.mtg_public_property ? window.mtg_public_property[propertyName] : undefined
}

export function getUrlParams(url) {
    var i
    url = url || window.location
    url = url.indexOf ? url : url.toString()
    url = decodeURIComponent(url)

    var paramStringStart = url.indexOf('?') + 1,
        paramStringEnd = (url.indexOf('#') === -1) ? url.length : url.indexOf('#'),
        paramString = url.slice(paramStringStart, paramStringEnd),
        keysAndValues = paramString.split('&'),
        paramsObject = {}

    for (i = 0; i < keysAndValues.length; i++) {
        var keyValue = keysAndValues[i].split('=')

        if (keyValue[0].slice(-2) === '[]') {
            var key = keyValue[0].slice(0, -2)
            paramsObject[key] = paramsObject[key] || []
            paramsObject[key].push(keyValue[1])
        } else {
            paramsObject[keyValue[0]] = keyValue[1]
        }
    }

    return paramsObject
}

export async function getFilePathByRemoteUrl(url = '', unitId, type = 2) {
    console.log('获取 filePath : ')
    let filePath = {
        path: url
    }
    let resource = [{
        type,
        ref: url
    }]
    let filePathConfig = await VideoBridgeGetFileInfo({unitId, resource})
    if (filePathConfig && filePathConfig.resource && filePathConfig.resource[0] && filePathConfig.resource[0][url] && filePathConfig.resource[0][url].path) {
        filePath = filePathConfig.resource[0][url]
        console.log('获取 filePath =====================> : ', filePath)
    } else {
        console.warn('获取 filePath 失败: ', {url, filePathConfig})
    }
    return filePath
}

export function device() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/.+Mac OS X/); //ios终端
    return {
        isAndroid: isAndroid,
        isiOS: isiOS
    }
}

export function getMousePosition(event) {
    var e = event || window.event;
    var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
    var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
    var x = e.pageX || e.clientX;// + scrollX;
    var y = e.pageY || e.clientY;// + scrollY;
    console.log('x: ' + x + '\ny: ' + y);
    return {'x': x || 0, 'y': y || 0};
}

//获取native需要的参数
export function getParams2Native({id, title, desc, package_name, icon_url, image_url, image_size, impression_url, video_url, video_length, video_size, video_resolution, video_end_type, playable_ads_without_video, ctype, adv_imp, ad_url_list, t_imp, adv_id, click_url, notice_url, fca, fcb, template, ad_source_id, app_size, click_mode, rating, landing_type, ctatext, c_ct, ttc_ct, link_type, guidelines, reward_amount, reward_name, offer_type, storekit_time, c_toi, imp_ua, c_ua, gh_id, gh_path, bind_id, ad_tracking}) {
    return {
        id,
        title,
        desc,
        package_name,
        icon_url,
        image_url,
        image_size,
        impression_url,
        video_url,
        video_length,
        video_size,
        video_resolution,
        video_end_type,
        playable_ads_without_video,
        ctype,
        adv_imp,
        ad_url_list,
        t_imp,
        adv_id,
        click_url,
        notice_url,
        fca,
        fcb,
        template,
        ad_source_id,
        app_size,
        click_mode,
        rating,
        landing_type,
        ctatext,
        c_ct,
        ttc_ct,
        link_type,
        guidelines,
        reward_amount,
        reward_name,
        offer_type,
        storekit_time,
        c_toi,
        imp_ua,
        c_ua,
        gh_id,
        gh_path,
        bind_id,
        ad_tracking: {
            // impression: ad_tracking.impression,
            click: ad_tracking.click
        }
    };
}

//删除url参数
export function delParam(url, paramKey) {
    var urlParam = url.substr(url.indexOf("?") + 1);
    var beforeUrl = url.substr(0, url.indexOf("?"));
    var nextUrl = "";

    var arr = new Array();
    if (urlParam != "") {
        var urlParamArr = urlParam.split("&");

        for (var i = 0; i < urlParamArr.length; i++) {
            var paramArr = urlParamArr[i].split("=");
            if (paramArr[0] != paramKey) {
                arr.push(urlParamArr[i]);
            }
        }
    }

    if (arr.length > 0) {
        nextUrl = "?" + arr.join("&");
    }
    url = beforeUrl + nextUrl;
    return url;
}

export function checkScreenOrientation() {
    if (typeof window.orientation === 'number') {
        if (window.orientation === 0) {
            return 'portrait';
        }
        if (window.orientation === 90 || window.orientation === -90) {
            return 'landscape';
        }
    } else {
        return (window.innerWidth > window.innerHeight) ? 'landscape' : 'portrait';
    }
}

/**
 * 拼接click_url
 * @param {object} defaultCampaign
 * @param {object} clickPosition 点击坐标对象
 * @param {object} bridgeContext v3接口上下文
 */
export function setClickUrl(defaultCampaign, clickPosition, bridgeContext) {
    let _data = bridgeContext;
    const _scale = clickPosition.scale;
    const cdnate_cfg = _data.appSetting.cdnate_cfg;
    let device_width = '';
    let device_height = '';
    if (_data.device) { // 安卓sdk 9.7.0 及以下不返回device字段
        device_width = _data.device.screen_width ? _data.device.screen_width : "";
        device_height = _data.device.screen_height ? _data.device.screen_height : "";
        if (device().isiOS) {
            device_width = (_data.device.device_width ? _data.device.device_width : 0) * _scale;
            device_height = (_data.device.device_width ? _data.device.device_width : 0) * _scale;
        }
    }
    let click_url = defaultCampaign.click_url;
    let rel = /.+:\/\/(.*?)\//;
    let relhost = rel.exec(click_url)
    let host = relhost ? relhost[1] : '';
    let tar = {
        x: parseInt(clickPosition.x),
        y: parseInt(clickPosition.y),
        width: parseInt(device_width || window.screen.width),
        height: parseInt(device_height || window.screen.height)
    }

    if (cdnate_cfg && cdnate_cfg[host]) {
        let item = cdnate_cfg[host];
        for (let k in item) {
            let arr = item[k]
            for (let i = 0; i < arr.length; i++) {
                click_url = click_url.replace(new RegExp(arr[i], 'g'), tar[k])
            }
        }
    }
    defaultCampaign.click_url = click_url
    return defaultCampaign
}

/**
 * 拼接notice_url，点击坐标宏上报拼接
 * @param {object} defaultCampaign,campaign对象
 * @param {object} clickPosition 点击坐标对象 ，包括x,y,scale
 * @param {boolean} autoClick 是否为自动storekit
 */
export function setNoticeUrl(defaultCampaign, clickPosition, startPoint, autoClick, ctabanner) {
    let notice_url = defaultCampaign.notice_url;
    // 以下为所有点击坐标宏需要上报的参数，先删除，再重新拼接
    notice_url = delParam(defaultCampaign.notice_url, 'click_x');
    notice_url = delParam(notice_url, 'click_y');
    notice_url = delParam(notice_url, 'click_ori');
    notice_url = delParam(notice_url, 'click_senario');
    notice_url = delParam(notice_url, 'click_scale');
    notice_url = delParam(notice_url, 'webviewStartX');
    notice_url = delParam(notice_url, 'webviewStartY');
    notice_url = delParam(notice_url, 'webviewWidth');
    notice_url = delParam(notice_url, 'webviewHeight');
    notice_url += `&webviewWidth=${document.body.clientWidth * clickPosition.scale}&webviewHeight=${document.body.clientHeight * clickPosition.scale}`;
    notice_url += `&webviewStartX=${Number(startPoint.startX)}&webviewStartY=${Number(startPoint.startY)}`;
    if (!autoClick) {//只有在不是自动storekit的情况下，拼接横纵坐标和方向
        let ori = checkScreenOrientation() === 'portrait' ? 1 : 2;
        notice_url += `&click_x=${parseInt(clickPosition.x)}&click_y=${parseInt(clickPosition.y)}&click_ori=${ori}`;
    }
    if (device().isAndroid) {//安卓额外拼接scale
        notice_url += '&click_scale=' + clickPosition.scale;
    }
    let isAutoClick = autoClick ? 2 : 0;//这个变量为了传click_senario
    notice_url += `&click_senario=${isAutoClick}`;//click_senario=0 表示不是自动点击，2 是自动点击，0 表示误点击
    if (ctabanner) {
        notice_url += "&endScreenType=3"
    }
    defaultCampaign.notice_url = notice_url;
    return defaultCampaign
}

export function parseCode (){
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    var charsto = 'vSoajc7dRzpWifGyNxZnV5k+DHLYhJ46lt0U3QrgEuq8sw/XMeBAT2Fb9P1OIKmC'

    var encode = function(input) {
        var tempVal = window.btoa(input)
        var code = ''
        tempVal = tempVal.split('')
        tempVal.map(function(val) {
            if (chars.indexOf(val) != -1) {
                code += charsto.split('')[chars.indexOf(val)]
            } else {
                code += val
            }
        })
        return code
    }

    var decode = function(input) {
        var tempVal = input
        var code = ''
        tempVal = tempVal.split('')
        tempVal.map(function(val) {
            if (charsto.indexOf(val) != -1) {
                code += chars.split('')[charsto.indexOf(val)]
            } else {
                code += val
            }
        })
        try {
            return window.atob(code)
        } catch (e) {
            return ''
        }
    }

    return {
        encode64: encode,
        decode64: decode
    }
}

export function isURL (str){
    return !!str.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi)
}

export function pos_fun (src){
    var win = window;
    var n = (+new Date()) + '.r' + Math.floor(Math.random() * 1000);
    var img = win[n] = new Image();
    img.onload = img.onerror = function() {
        win[n] = null;
    };
    img.src = src;
}

// 替换所有clickurl中的appflyerhost
export function replaceAppFlyerHost(res) {
    var token = window.AF_SDK && window.AFEVENT && window.AF_SDK.getToken(window.AFEVENT)
    if (!token) return;

    function replaceElement(ele) {
        return ele.replace('[af_token]', token)
    }

    res.click_url = replaceElement(res.click_url);
    res.notice_url = replaceElement(res.notice_url);
    res.ad_tracking && res.ad_tracking.click && (res.ad_tracking.click = res.ad_tracking.click.map(function (item) {
        return replaceElement(item)
    }))

}

// 判断是否是appflyer
export function getAppFlyerRoute(res) {
    // 由于有多offer，暂时默认都会引入该文件
    // var arr = [res.click_url, res.notice_url]
    // if(res.ad_tracking && res.ad_tracking.click){
    //     arr = arr.concat(res.ad_tracking.click)
    // }
    //
    // var isAppFlyer = arr.some(function(item){
    //     return item.indexOf('[af_token]') > -1
    // })
    // if(!isAppFlyer) return;

    (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://fvalid.appsflyer.com/mintegral/cp.sdk.1.2.6.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'AppsFlyer-jssdk'));

    window.onAFReady = function (AF) {
        console.log("onAFReady加载成功")
        console.log("AF",AF)
        window.AF_SDK = AF
        document.body.addEventListener("touchstart", function (e) {
            window.AFEVENT = e
            // console.log("window.AFEVENT",window.AFEVENT)
        });
    };
}
export function sendAdtracking (url){
    if(device().isiOS) return;
    if(!url) return;
    url = parseCode().decode64(url)
    if(isURL(url)){
        pos_fun(url)
    }
}
/**
 * 判断当前 SDK 版本是否大于等于指定版本, 此方法假定版本号以小数点分隔, 并且只会对比前三部分的数字
 * @param {string} currentSDKVersion 当前 SDK 的版本号
 * @param {string} iosMin 要比较的 iOS 版本号, 如果当前为 iOS SDK, 则使用此版本号进行对比
 * @param {string} androidMin 要比较的 Android 版本号, 如果当前为 Android SDK, 则使用此版本号进行对比
 * @returns {boolean} 如果当前版本号大于等于指定版本, 返回 true, 否则返回 false
 */
function checkSDKVersion({currentSDKVersion = '', iosMin = '', androidMin = ''} = {}) {
    // 确认数据合法性
    if (!currentSDKVersion || (!iosMin && !androidMin)) {
        return false
    }

    // 特殊兼容: 由于安卓某些版本可能返回 sdk_info: "MAL_9.6.0,3.0.1" 的形式, 所以需要对这种不规则的版本格式进行兼容
    if (device().isAndroid) {
        currentSDKVersion = currentSDKVersion.split(',')[0]
    }

    // 清除多余前后缀
    let arrSDKVer = currentSDKVersion.split('_')[1].split('.')
    let arrMinVer

    // 确认要对比的平台(iOS/Android)
    if (device().isiOS) {
        arrMinVer = iosMin.split('.').map(item => Number(item))
    } else if (device().isAndroid) {
        arrMinVer = androidMin.split('.').map(item => Number(item))
    } else {
        // 无法确认当前系统, 始终返回 false
        return false
    }

    // 返回对比结果
    return arrSDKVer[0] > arrMinVer[0]
        ||
        arrSDKVer[0] > arrMinVer[0]
        && arrSDKVer[1] >= arrMinVer[1]
        ||
        arrSDKVer[0] >= arrMinVer[0]
        && arrSDKVer[1] >= arrMinVer[1]
        && arrSDKVer[2] >= arrMinVer[2]
}

export function checkAndroidSDKVersion({currentSDKVersion = '', minVersion = ''}) {
    return checkSDKVersion({currentSDKVersion, androidMin: minVersion})
}

export function checkIosSDKVersion({currentSDKVersion = '', minVersion = ''}) {
    return checkSDKVersion({currentSDKVersion, iosMin: minVersion})
}

export function parseDom(html) {
    let ele = document.createElement('div')
    ele.innerHTML = html
    return ele.childNodes[0]
}